import { render, staticRenderFns } from "./PageEditorToolbarAddContentBtn.vue?vue&type=template&id=419d2d98&scoped=true"
import script from "./PageEditorToolbarAddContentBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbarAddContentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419d2d98",
  null
  
)

export default component.exports